<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 19 18">
    <path
      d="M15.6037 1.125V0H12.2601V1.125H6.68731V0H3.34365V1.125H0V18H18.9474V1.125H15.6037ZM13.3746 1.125H14.4892V3.375H13.3746V1.125ZM4.4582 1.125H5.57276V3.375H4.4582V1.125ZM17.8328 16.875H1.11455V6.84H17.8328V16.875ZM1.11455 5.715V2.25H3.34365V4.5H6.68731V2.25H12.2601V4.5H15.6037V2.25H17.8328V5.715H1.11455Z"
      :class="colorClass"
    />

    <path d="M16.4473 9V10.125H3.07739V9H16.4473Z" :class="colorClass" />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
